import React from 'react';
import PropTypes from 'prop-types';

const GetStartedModal = ({ show, onComplete }) => {
  console.log('GetStartedModal rendered with show:', show);
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 shadow-lg max-w-md w-full text-center space-y-4">
        {/* Brand Emphasis */}
        <div className="space-y-4">
          <h1 className="text-3xl font-extrabold text-black">
            Welcome To
          </h1>
          
          {/* Logo */}
          <div className="flex justify-center">
            <h2 className="text-4xl font-extrabold tracking-tight text-[#001427]">
              Tennis<span className="text-[#F4C112]">Now</span>App
            </h2>
          </div>
        </div>

        {/* Main Slogan */}
        <div className="space-y-1">
          <h3 className="text-xl font-bold text-black">
            Find & Play
          </h3>
          <h3 className="text-xl font-bold text-[#0f9b84]">
            With More
          </h3>
          <h3 className="text-xl font-bold text-black">
            Players In Seconds
          </h3>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 pt-4">
          {/* Secondary Tagline */}
          <p className="text-gray-500 text-sm">
            Connecting the Triangle's Tennis Community
          </p>
        </div>

        {/* Call-to-Action Button */}
        <button
          onClick={onComplete}
          className="w-full bg-[#0f9b84] text-white font-semibold py-2 rounded-md hover:bg-[#0c7f6a] transition"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

GetStartedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onComplete: PropTypes.func.isRequired
};

export default GetStartedModal; 